export const tokenCopomex = '90641157-e1c1-43a6-bc04-7b0f4dd07fc4'


// export const host = 'http://52.22.169.24:7779/api/v1/'
// export const hostSocket = 'http://52.22.169.24:7779'
// export const hostMetricas = ''//'http://52.22.169.24:7781/api/v1/'
// export const hostInformacionComercial = 'http://52.22.169.24:7783/api/v1/'
// export const hostUI = 'http://52.22.169.24:7785/api/v1/'

export const host = 'http://52.22.169.24:7777/api/v1/'
export const hostSocket = 'http://52.22.169.24:7777'
export const hostMetricas = 'http://52.22.169.24:7781/api/v1/'
export const hostInformacionComercial = 'http://52.22.169.24:7783/api/v1/'
export const hostUI = 'http://52.22.169.24:7785/api/v1/'

// export const host = 'http://localhost:7777/api/v1/'
// export const hostSocket = 'http://localhost:7777'
// export const hostMetricas = 'http://localhost:7781/api/v1/'
// export const hostInformacionComercial = 'http://localhost:7779/api/v1/'
// export const hostUI = 'http://localhost:7785/api/v1/'
// export const hostUI = 'http://52.22.169.24:7785/api/v1/'


